import { useContext, useEffect, useState } from "react";
import { func, node, object, oneOfType, string } from "prop-types";
import { Link } from "react-router-dom";

import { AnalyticsContext } from "../analytics/Analytics.context";

import { URL_NEW_SITE } from "../../constants";

function NewLink({ children, to, ...rest }) {
  const [path, setPath] = useState("");

  useEffect(() => {
    if (typeof to === "string" || to instanceof String) {
      setPath(to);
    } else if (!!to.pathname) {
      setPath(to.pathname);
    }
  }, [to]);

  return (
    <a href={`${URL_NEW_SITE}${path}`} {...rest}>
      {children}
    </a>
  );
}

function UsedLink({ children, ...rest }) {
  return <Link {...rest}>{children}</Link>;
}

export default function SourceTypeLink({
  analyticsAction = "Equipment",
  analyticsLabel = "link",
  onClick,
  sourceType = "used",
  ...rest
}) {
  const { trackEvent, trackOutboundLink } = useContext(AnalyticsContext);

  function handleClick(event) {
    if (onClick) {
      onClick();
    }

    if (sourceType === "new" && !!trackOutboundLink) {
      trackOutboundLink(event, {
        action: analyticsAction,
        label: analyticsLabel,
      });
    } else if (!!trackEvent) {
      trackEvent({
        category: "click",
        action: analyticsAction,
        label: analyticsLabel,
      });
    }
  }

  return sourceType === "new" ? (
    <NewLink onClick={handleClick} {...rest} />
  ) : (
    <UsedLink onClick={handleClick} {...rest} />
  );
}

SourceTypeLink.propTypes = {
  analyticsAction: string,
  analyticsLabel: string,
  children: node.isRequired,
  onClick: func,
  sourceType: string,
  to: oneOfType([object, string]).isRequired,
};
